export const suklAdministrationRouteSelectFrag = `
    id
    code
    name
`;

export const suklPharmaceuticalFormSelectFrag = `
    id
    code
    name
    cannabis
`;

export const folderEPrescriptionAnamnesisFrag = `
    id
    folderId
    diagnosis {
        code
    }
`;
